window.M = window.M || {};
window.M.Editor = function(options) {
    var self = this;
    
    this.template = options.template;
    this.storeData = options.storeData;
    this.deleteData = options.deleteData;
    this.prepareData = options.prepareData;
    this.fields = options.fields;
    this.title = options.title;
    this.buttons = options.buttons;
    this.onshow = options.onshow;
    this.collectData = options.collectData;
    this.validate = options.validate;
    
    this.lightbox = $.parseHTML(M.templates.modal({
        buttons: this.buttons,
		size: 'modal-lg'
    }));
    
    $(document.body).append(this.lightbox);
    
    $(this.lightbox).modal({
        show:false
    });
    $(this.lightbox).on('hide.bs.modal', function() {
        if(self.onComplete) self.onComplete();
    });
    $(this.lightbox).on('shown.bs.modal', function() {
        if(self.onshow) self.onshow(self.canv, self.data);
    });
    
    $(".modal-footer", this.lightbox).delegate("button", "click", function() {
        if($(this).data("id") == "save") {
            if(!self.validate || self.validate()) {
                self.storeData(self.getData(), function(err) {
                    if(!err) {
                        self.close();
                    }
                });
            }
        } else if($(this).data("id") == "cancel") {
            self.close();
        } else if($(this).data("id") == "delete" && self.deleteData) {
            if(confirm("Are you sure you would like to delete this item? This cannot be undone!")) {
                self.deleteData(self.getData(), function(err) {
                    if(err) {
                        
                    }
                    self.close();
                });
            }
        }
    });
};

window.M.Editor.prototype = {
    startEditing: function(data, onComplete) {
        if(typeof(data) == "function" && !onComplete) {
			onComplete = data;
			data = null;
		}
		
        this.data = data || { isNew: true };
        
        var self = this;
        self.onComplete = onComplete;
        
        $(self.lightbox).modal('show');
        
        self.canv = $(".modal-body", self.lightbox);
        self.canv.html(M.templates.loading());
        
        $(".modal-title", self.lightbox).html(self.title);
        
        if(self.prepareData) {
            self.data = self.prepareData(self.data);
        }
        
        self.canv.html(self.template(self.data));
        
    },
    
    getData: function() {
        var ret = {};
        var self = this;
        
        if(self.collectData) {
            return self.collectData(self.canv);
        } else {
            for(var k = 0; k < this.fields.length; k++) {
                var f = $("." + this.fields[k], self.canv);
                if(f.attr("type") == "checkbox") {
                    ret[this.fields[k]] = f[0].checked;
                } else {
                    ret[this.fields[k]] = f.val();
                }
            }
        }
        
        return ret;
    },
    
    close: function() {
        $(this.lightbox).modal('hide');
    },
    
};